<template>
    <li class="nav-item dropdown">
        <a class="nav-icon dropdown-toggle" href="#" id="creditCalculatorDropdown" data-toggle="dropdown"
           aria-haspopup="true" aria-expanded="false">
            <div class="position-relative">
                <i class="fas fa-calculator"></i>
            </div>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="creditCalculatorDropdown"
             style="width: 25rem;">
            <div data-v-143e2034="" class="dropdown-menu-header">
                Кредитный калькулятор
            </div>
            <form class="p-4" action="">
                <div class="form-row">
                    <div class="form-group col-sm-6">
                        <label class="mb-1" for="init">Первоначальный взнос</label>
                        <input type="number" class="form-control" id="init" v-model="init">
                    </div>
                    <div class="form-group col-sm-6">
                        <label class="mb-1" for="sum">Стоимость авто</label>
                        <input type="number" class="form-control" id="sum" v-model="sum">
                    </div>
                    <div class="form-group col-sm-6">
                        <label class="mb-1" for="period">Срок кредита, мес</label>
                        <input type="number" class="form-control" id="period" v-model="period">
                    </div>
                    <div class="form-group col-sm-6">
                        <label class="mb-1" for="rate">Процентная ставка, %</label>
                        <input type="number" class="form-control" id="rate" v-model="rate">
                    </div>
                    <div class="form-group col-12 mb-0" v-if="result">
                        <table class="table table-borderless mb-0">
                            <tbody>
                            <tr>
                                <td>Ежемесячный платеж</td>
                                <td>{{ result.payment }}</td>
                            </tr>
                            <tr>
                                <td>Общая сумма выплат</td>
                                <td>{{ result.amount + result.overpayment }}</td>
                            </tr>
                            <tr>
                                <td>Переплата по кредиту</td>
                                <td>{{ result.overpayment }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </form>
        </div>
    </li>
</template>

<script>
import Credit from "../../plugins/credit";

export default {
    name: "CreditCalculator",
    data: () => ({
        init: null,
        sum: null,
        period: null,
        rate: null,
    }),
    computed: {
        result() {
            let init = parseInt(this.init);
            let sum = parseInt(this.sum);
            let period = this.period ? parseInt(this.period) : null;
            let rate = this.rate ? parseFloat(this.rate.replace(',', '.')) : null;

            if (isNaN(init)) init = null;
            if (isNaN(sum)) sum = null;
            if (isNaN(period)) period = null;
            if (isNaN(rate)) rate = null;
            if (init === null) init = 0;

            if (sum !== null && period !== null && rate !== null) {
                return Credit.calculate(sum, period, rate, init);
            }
            return null;
        }
    }
}
</script>

<style scoped>

</style>
